import { useEffect, useState } from "react";
import { MapContainer, TileLayer, Polyline, Marker, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { api } from "@/lib/api";

const numIcon = (n) =>
  L.divIcon({
    className: "",
    iconSize: [24, 24],
    iconAnchor: [12, 12],
    html: `<div style="width:24px;height:24px;border-radius:9999px;background:#6366f1;color:#fff;font:700 11px sans-serif;display:flex;align-items:center;justify-content:center;border:2px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,.5)">${n}</div>`,
  });

function FitBounds({ pts }) {
  const map = useMap();
  useEffect(() => {
    if (pts.length === 1) map.setView(pts[0], 13);
    else if (pts.length) map.fitBounds(pts, { padding: [24, 24] });
  }, [map, pts]);
  return null;
}

const LeafletMap = ({ pts }) => (
  <MapContainer
    center={pts[0]}
    zoom={12}
    scrollWheelZoom={false}
    style={{ height: "100%", width: "100%", background: "#18181b" }}
  >
    <TileLayer
      attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
      className="route-map-dark-tiles"
    />
    <Polyline positions={pts} pathOptions={{ color: "#818cf8", weight: 3, dashArray: "6 6" }} />
    {pts.map((p, i) => (
      <Marker key={`${p[0]}-${p[1]}-${i}`} position={p} icon={numIcon(i + 1)} />
    ))}
    <FitBounds pts={pts} />
  </MapContainer>
);

export const RouteMap = ({ order, crew }) => {
  const pts = order.filter((o) => o.lat != null && o.lng != null).map((o) => [o.lat, o.lng]);
  const key = pts.map((p) => `${p[0]},${p[1]}`).join(";");
  const [imgUrl, setImgUrl] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!key) return undefined;
    let active = true;
    let objectUrl = null;
    setImgUrl(null);
    setFailed(false);
    api
      .get(`/route/staticmap?stops=${encodeURIComponent(key)}&size=640x260`, {
        responseType: "blob",
      })
      .then(({ data }) => {
        if (!active) return;
        objectUrl = URL.createObjectURL(data);
        setImgUrl(objectUrl);
      })
      .catch(() => active && setFailed(true));
    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [key]);

  if (!pts.length) return null;

  return (
    <div
      className="relative isolate z-0 h-52 overflow-hidden border-b border-white/5"
      data-testid={`route-map-${crew}`}
    >
      {!failed ? (
        imgUrl ? (
          <img
            src={imgUrl}
            alt={`Route map for ${crew}`}
            data-testid={`route-map-google-${crew}`}
            className="h-full w-full object-cover"
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center bg-zinc-900 text-xs text-zinc-500">
            Loading map…
          </div>
        )
      ) : (
        <LeafletMap pts={pts} />
      )}
    </div>
  );
};
